


















































import { Component, Vue } from "vue-property-decorator";

const PandoHref = "https://app.pando.im";
const PandoBotHref = "mixin://apps/44a80608-8512-45e8-8797-e75d801f413d";
const TeamMixinBotHref = "mixin://users/773e5e77-4107-45c2-b648-8fc722ed77f5";

@Component
class Redirection extends Vue {
  PandoBotHref = PandoBotHref;

  handleToTeamMixin() {
    window.location.href = TeamMixinBotHref;
  }

  handleToMixinBot() {
    window.location.href = PandoBotHref;
  }

  handleToHFox() {
    window.location.href = PandoHref + "/earn/auto-invest";
  }

  handleToEarn() {
    window.location.href = "mixin://apps/" + "/earn";
  }

  handleToTrade() {
    window.location.href = PandoHref;
  }
}
export default Redirection;
